import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

import { getSchedulerConfigs } from '../../configs/schedulerConfigs'

export const schedulerConfigs = getSchedulerConfigs()

export const schedulerFlowDirectionTypes = [
    {
        id: "in",
        label: "Inflow"
    },
    {
        id: "out",
        label: "Outflow"
    },
]

export const schedulerTypes = {
    schedulerTask: "scheduler_task",
    schedulerLog: "scheduler_log",
    schedulerRequest: "scheduler_request"
}

export const targetTypes = {
    schedulerTask: "scheduler_task",
    schedulerLog: "scheduler_log",
    schedulerRequest: "scheduler_request"
}

export const schedulerTargets = {
    request: {
        repository: "repository",
        item: "item"
    }
}

export const schedulerModules = {
    request: {
        repository: {
            container: "container"
        },
        item: {
            product: "product",
            item: "item"
        }
    }
}

export const schedulerRefs = {
    request: {
        repository: {
            container: "repository"
        },
        item: {
            product: "item",
            item: "item"
        }
    }
}

export function useSchedulers({ 
    schedulerType: _schedulerType, 
    targetType: _targetType = "" 
}) {

    const [schedulerType, setSchedulerType] = useState(_schedulerType);
    const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "scheduler";
    const endpoint2 = "schedulers"

    const list = async (props) => {

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}/${schedulerType}`, props);

            // if (targetType) {
            //     url = getListsUrl(`${endpoint2}/${schedulerType}/${targetType}`, props);
            // }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({ data, schedulerType: _schedulerType, targetType: _targetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}`;

            // if (_schedulerType) {
            //     url = `${endpoint1}/${_schedulerType}`;
            // }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, schedulerType: _schedulerType, targetType: _targetType }) => {

        setIsLoading(true)

        try {

            // block from the log type cannot delete
            if (
                targetType === targetTypes.schedulerLog
            ) throw new Error(`Cannot update for type : ${targetType}`)

            let url = `${endpoint1}/${id}`

            // if (_schedulerType) {
            //     url = `${endpoint1}/${_schedulerType}/${id}`
            // }

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, schedulerType: _schedulerType, targetType: _targetType }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint2}/delete`

            // if (_schedulerType) {
            //     url = `${endpoint1}/${_schedulerType}/delete`
            // }

            // block from the log and request type cannot delete
            if (
                targetType === targetTypes.schedulerLog ||
                targetType === targetTypes.schedulerRequest
            ) throw new Error(`Cannot remove for type : ${targetType}`)

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if (_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = `${endpoint1}/${schedulerType}/${id}`

            if (dataTypesArray.length) {
                url = getUrlWithDataTypes(url, dataTypesArray)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        schedulerTypes,
        targetTypes,
        list,
        get,
        create,
        update,
        remove
    }
}